import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: 'Products', path: '/products' },
  { label: 'Brand Story', path: '/brand-story' },
  { label: 'Blog', path: '/blog' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/54d0c5d0466a0c807f4c52375a988d35/2dfcd75db5398e3e348be2319053c6c3.png"
            alt="Yunxin Logo"
            className="h-12 w-auto object-contain"
          />
          <div className="flex flex-col leading-tight">
            <span className={`text-base font-bold tracking-widest uppercase transition-colors duration-300 ${scrolled ? 'text-stone-900' : 'text-white'}`}>
              YUNXIN OUTDOOR
            </span>
            <span className={`text-xs tracking-wider transition-colors duration-300 ${scrolled ? 'text-stone-400' : 'text-white/60'}`}>
              云新户外用品
            </span>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium tracking-widest uppercase transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? scrolled ? 'text-stone-900' : 'text-white border-b border-white'
                  : scrolled ? 'text-stone-500 hover:text-stone-900' : 'text-white/80 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* CTA */}
        <Link
          to="/contact"
          className={`hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-xs font-semibold tracking-widest uppercase transition-all duration-300 whitespace-nowrap cursor-pointer ${
            scrolled
              ? 'bg-stone-900 text-white hover:bg-stone-700'
              : 'bg-white/20 text-white border border-white/40 hover:bg-white/30'
          }`}
        >
          Inquire Now
        </Link>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex flex-col justify-center gap-1.5 cursor-pointer ${scrolled ? 'text-stone-900' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block h-0.5 w-6 bg-current transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block h-0.5 w-6 bg-current transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block h-0.5 w-6 bg-current transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`md:hidden bg-white transition-all duration-300 overflow-hidden ${menuOpen ? 'max-h-96' : 'max-h-0'}`}>
        <nav className="flex flex-col px-6 py-4 gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium tracking-widest uppercase cursor-pointer ${
                location.pathname === link.path ? 'text-stone-900' : 'text-stone-500'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="mt-2 inline-flex items-center justify-center px-5 py-2.5 rounded-full bg-stone-900 text-white text-xs font-semibold tracking-widest uppercase whitespace-nowrap cursor-pointer"
          >
            Inquire Now
          </Link>
        </nav>
      </div>
    </header>
  );
}
